<template>
  <div class="box text-center">
    <!-- /.box-header -->
    <div class="box-body form">
      <br />
      <div><h3>複製此分店{{ titleType }}廣告至其他店家</h3></div>
      <p class="text-light-gray">將特定店家尚有效的廣告全數複製到指定同步的店家，原店家的有效廣告會立即刪除</p>
      <br />
      <div class="text-left">
        <h5>套用門市</h5>
        <div
          v-for="(storeClass, index) in storeClassList" class="m-r-5 m-b-10 inline-block"
          :key="`storeClass-${index}`"
        >
          <button
            class="btn btn-default"
            :class="{'active': curId === storeClass.id}"
            @click="clickOption(storeClass)"
          >
            {{storeClass.name}}
          </button>
        </div>
      </div>
      <div>
        <h5 class="text-left">參與店家</h5>
        <!-- 參與店家 -->
        <muti-select-two :setting="addStoresSetting" :reNew="reNew" :reSet="reSet"></muti-select-two>
      </div>
      <!--
      <div>
        <div class="input-group">
        <span class="input-group-addon">
          指定店家
        </span>
          <v-select v-model="bindingStoreList" :options="storeBrief" :multiple="true" class="h-38"></v-select>
        </div>
        <br />
      </div>
      -->
    </div>
    <div class="box-footer text-center">
      <router-link :to="'/adTable/' + $route.params.brand_id + '/' + $route.params.store_id">
        <button class="btn btn-default">
          取消
        </button>
      </router-link>
      <button class="btn btn-success" @click="copyAd()">
        確定
      </button>
    </div>
    <br />
  </div>
</template>
<script>
// import $ from 'jquery'
import ImgUploadTemp from './ImgUploadTemp.vue'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
// import moment from 'moment'
import VueTimepicker from 'vue2-timepicker'
// import 'src/static/js/plugins/notify/notify.min.js'
export default {
  props: {
    'info': {
      type: Object
    }
  },
  data () {
    return {
      bindingStoreList: [],
      storeBrief: [],
      syncBannerTypeList: Number(this.$route.query.tab) || [],
      addStoresSetting: {
        class: 'copy-store',
        options: [],
        choose: []
      },
      storeClassList: [],
      curId: 0,
      reNew: 0,
      reSet: 0
    }
  },
  methods: {
    init () {
      this.getStoreBrief()
    },
    getStoreBrief () {
      this.storeBrief = []
      this.addStoresSetting.options = []
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.getStoreClassList()
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            if (parseInt(sList[i].store_id, 10) !== parseInt(self.$route.params.store_id, 10)) {
              self.storeBrief.push(obj)
              self.addStoresSetting.options.push(obj)
            }
          }
        }
      })
    },
    getStoreClassList () {
      var self = this
      var url = 'brand/' + this.$route.params.brand_id + '/storeClassList'
      if (this.getRoleType === 10) url = 'store/' + this.$route.params.brand_id + '/storeClassList'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          self.storeClassList = sList
        }
      })
    },
    copyAd () {
      var self = this
      var url = '/store/syncBanner'
      let syncList = ''
      for (let i = 0; i < this.addStoresSetting.choose.length; i++) {
        syncList = syncList + this.addStoresSetting.choose[i] + ','
      }
      syncList = syncList.slice(0, -1)
      var data = {
        store_id: parseInt(this.$route.params.store_id, 10),
        sync_store_ids: syncList,
        sync_banner_type_list: this.syncBannerTypeList
      }
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.push({path: '/storeTable/' + self.$route.params.brand_id})
        }
      })
    },
    clickOption (option) {
      var self = this
      this.addStoresSetting.options = []
      self.curId = option.id
      if (self.curId) {
        self.$nextTick(function () {
          self.reSet++
          self.addStoresSetting.options = self.storeBrief
          self.getCurStoreClass()
        })
      }
    },
    getCurStoreClass () {
      this.addStoresSetting.choose = []
      var self = this
      var url = 'brand/' + this.$route.params.brand_id + '/storeClass/' + this.curId
      if (this.getRoleType === 10) url = 'store/' + this.$route.params.brand_id + '/storeClass/' + this.curId
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var classInfo = response.data.class
          classInfo.store_list.forEach(function (s) {
            self.addStoresSetting.choose.push(s.id)
          })
        }
      })
    }
  },
  created () {
    this.init()
  },
  components: {
    'img-upload': ImgUploadTemp,
    'date-time-picker': datetimePicker,
    VueTimepicker
  },
  computed: {
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    },
    titleType () {
      let title = '所有'
      if (this.syncBannerTypeList === 12) {
        title = '橫幅'
      } else if (this.syncBannerTypeList === 41) {
        title = '蓋版'
      }
      return title
    }
  },
  watch: {
    citySelect () {
      var cityCode = parseInt(this.citySelect, 10)
      var cityElement = this.cityAreaList.find(function (e, i, o) {
        return e.city_code === cityCode
      })
      let areaList = cityElement.area_list
      for (var i = 0; i < areaList.length; i++) {
        var option = {name: areaList[i].name, value: areaList[i].area_code}
        this.areaOption.push(option)
        if (i === 0 && this.$route.name !== 'upStore') this.areaSelect = areaList[i].area_code
      }
      if (this.$route.name === 'upStore') this.areaSelect = this.storeInfo.area_code
    },
    imgLogoSelect () {
      var self = this
      if (self.imgLogoSelect) {
        let imgSrc = this.imgLogoOption.find(function (e) {
          return e.name === self.imgLogoSelect
        }).value
        this.storeInfo.image_name = imgSrc
      }
    },
    imgBgSelect () {
      var self = this
      if (self.imgBgSelect) {
        let imgSrc = this.imgBgOption.find(function (e) {
          return e.name === self.imgBgSelect
        }).value
        this.storeInfo.bg_image_name = imgSrc
      }
    },
    'deliveryWaysInfo' () {
      this.checkOtherDelivery()
    }
  }
}
</script>



// WEBPACK FOOTER //
// CopyAdTemp.vue?195d9d29